import React from 'react';
import '../styles/theme.css';
import '../styles/Shipments.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ShipmentsWorkspaceShell from '../components/ShipmentsWorkspaceShell';
import ShipmentsRegistry from '../components/ShipmentsRegistry';
/* IMPORTS */

function ShipmentsPage() {
  return (
    <div className="sh-root">
      <div id="shipmentsnavbar" className="sh-slot-shipmentsnavbar">
        <Navbar activePage={"Shipments"} />
      </div>
      <div id="shipmentsworkspaceshell" className="sh-slot-shipmentsworkspaceshell">
        <ShipmentsWorkspaceShell />
      </div>
      <div id="shipmentsregistry" className="sh-slot-shipmentsregistry">
        <ShipmentsRegistry />
      </div>
      <div id="shipmentsfooter" className="sh-slot-shipmentsfooter">
        <Footer />
      </div>
    </div>
  );
}

export default ShipmentsPage;
